import httpUtil from '@/utils/axios'

export const ProductionWorkOrdersAPI = {
  list: (params = {}) => httpUtil.get('/production-work-orders', params),
  getById: (id) => httpUtil.get(`/production-work-orders/${id}`),
  getLogs: (id) => httpUtil.get(`/production-work-orders/${id}/logs`),
  getFollowups: (id) => httpUtil.get(`/production-work-orders/${id}/followups`),
  addFollowup: (id, payload) => httpUtil.post(`/production-work-orders/${id}/followups`, payload),
  create: (payload) => httpUtil.post('/production-work-orders', payload),
  update: (id, payload) => httpUtil.put(`/production-work-orders/${id}`, payload),
  updateStatus: (id, status) => httpUtil.put(`/production-work-orders/${id}/status`, {}, { params: { status } }),
  deleteById: (id) => httpUtil.delete(`/production-work-orders/${id}`),
  uploadImage: (file, onProgress) => httpUtil.upload('/production-work-orders/images', file, onProgress)
}

export default ProductionWorkOrdersAPI
